import { render, staticRenderFns } from "./SaleInvoicesCategorySelect.vue?vue&type=template&id=71758b3a&scoped=true&"
import script from "./SaleInvoicesCategorySelect.vue?vue&type=script&lang=js&"
export * from "./SaleInvoicesCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71758b3a",
  null
  
)

export default component.exports